import { createGrid, themeQuartz } from 'ag-grid-community'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { setGridHeight } from './set-grid-height.js'

export function showDetailGrid (params) {
  console.log('showDetailGrid', params)

  const { containerElementId, emptyMessage, rows, columnDefs, includeFilterRow, maxRows = 10 } = params

  const gridContainerElement = setElementHtml(containerElementId, '')
  if (!gridContainerElement) return

  if (!rows || rows.length === 0) {
    setElementHtml(gridContainerElement, emptyMessage)
    return
  }

  const gridOptions = {
    rowData: rows,
    columnDefs,
    theme: themeQuartz,
    onCellClicked: function (cellParams) {
      console.log('grid onCellClicked', cellParams)
    }
  }
  if (includeFilterRow) {
    gridOptions.defaultColDef = {
      filter: true,
      floatingFilter: true
    }
  }
  console.log('gridOptions', gridOptions)

  setGridHeight({ gridContainerElement, numberOfRows: rows.length, maxRows, includeFilterRow })

  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('gridApi', gridApi)
}
